module.exports = {"title":"Nutzungsbedingungen","short":{"sympa":{"text":"Wir sind nette Leute:"}}};